<template>
  <div class="wrapper">
    <password-reset-request-form
      :title="$t('app.help.forgotUsername')"
      :blurb="$t('app.help.forgotUsernameBlurb')"
      :input-field-default="$t('app.help.forgotUsernameDefault')"
      :status-message="usernameRequestMessage"
      @forgot="handleUsernameRequest($event)"
    />
  </div>
</template>

<script>
import PasswordResetRequestForm from '@/app/components/PasswordResetRequestForm';
import { helpService } from '../help.service';
export default {
  components: {
    PasswordResetRequestForm
  },
  data() {
    return {
      usernameRequestMessage: null
    };
  },
  methods: {
    async handleUsernameRequest(evt) {
      const result = await helpService.requestUsernameReminder(evt);
      this.usernameRequestMessage =
        result && result.usernameSent
          ? this.$t('app.help.forgotUsernameSuccessMessage')
          : this.$t('app.help.forgotUsernameErrorMessage');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.wrapper {
  background-color: $white;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
